import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import Loader from "../Loader/Loader";

const CustomerLoyalty = (props) => {
  const [visibleCustomerLoyalty, setVisibleCustomerLoyalty] = useState(false);
  const [formValues, setFormValues] = useState({
    EnableCustomerLoyaltySystem: false,
    DisableLoyaltyByDefault: false,
    LoyaltyProgramOption: "",
    SpendAmountToPointRatio: "",
    SpendAmountToPointRatio1: "",
    PointValue: "",
    MinimumNumberOfPointsToRedeem: "",
    LoyaltyPointsEarnedNotIncludingTax: false,
    PromptToUsePointsWhenAvailable: false,
    HidePointsOnReceipt: false,
    DisableGiftCardsSoldFromEarningLoyalty: false,
    EnablePointsForGiftCardPayments: false,
    NumberOfSalesForDiscount: "",
    DiscountPercentEarnedWhenReachingSales: "",
    HideSalesToDiscountOnReceipt: false,
  });
  const [loading, setLoading] = useState(false);
  const [comingCustomerLoyalty, setcomingCustomerLoyalty] = useState(
    props.visibleCustomerLoyaltyChange
  );
  const [loyaltyProgramOptionAdvanced, setLoyaltyProgramOptionAdvanced] =
    useState(false);
  const [loyaltyProgramOptionSimple, setLoyaltyProgramOptionSimple] =
    useState(true);
  const [enableCustomerLoyaltySystem, setEnableCustomerLoyaltySystem] =
    useState(false);

  const handleLoyaltyProgramOption = (e) => {
    if (e.target.value === "Advanced") {
      setLoyaltyProgramOptionSimple(false);
      setLoyaltyProgramOptionAdvanced(true);
    } else {
      setLoyaltyProgramOptionAdvanced(false);
      setLoyaltyProgramOptionSimple(true);
    }
  };

  const handleEnableCustomerLoyaltySystem = () => {
    setEnableCustomerLoyaltySystem(!enableCustomerLoyaltySystem);
  };

  const token = localStorage.getItem("Token");

  //handleChange
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  const handleSubmit = (values) => {
    const formArray = [
      {
        AppConfigkey: "EnableCustomerLoyaltySystem",
        AppConfigvalue: values.EnableCustomerLoyaltySystem,
      },
      {
        AppConfigkey: "DisableLoyaltyByDefault",
        AppConfigvalue: values.DisableLoyaltyByDefault,
      },
      {
        AppConfigkey: "LoyaltyProgramOption",
        AppConfigvalue: values.LoyaltyProgramOption,
      },
      {
        AppConfigkey: "SpendAmountToPointRatio",
        AppConfigvalue: values.SpendAmountToPointRatio,
      },
      {
        AppConfigkey: "SpendAmountToPointRatio1",
        AppConfigvalue: values.SpendAmountToPointRatio1,
      },
      { AppConfigkey: "PointValue", AppConfigvalue: values.PointValue },
      {
        AppConfigkey: "MinimumNumberOfPointsToRedeem",
        AppConfigvalue: values.MinimumNumberOfPointsToRedeem,
      },
      {
        AppConfigkey: "LoyaltyPointsEarnedNotIncludingTax",
        AppConfigvalue: values.LoyaltyPointsEarnedNotIncludingTax,
      },
      {
        AppConfigkey: "PromptToUsePointsWhenAvailable",
        AppConfigvalue: values.PromptToUsePointsWhenAvailable,
      },
      {
        AppConfigkey: "HidePointsOnReceipt",
        AppConfigvalue: values.HidePointsOnReceipt,
      },
      {
        AppConfigkey: "DisableGiftCardsSoldFromEarningLoyalty",
        AppConfigvalue: values.DisableGiftCardsSoldFromEarningLoyalty,
      },
      {
        AppConfigkey: "EnablePointsForGiftCardPayments",
        AppConfigvalue: values.EnablePointsForGiftCardPayments,
      },
      {
        AppConfigkey: "NumberOfSalesForDiscount",
        AppConfigvalue: values.NumberOfSalesForDiscount,
      },
      {
        AppConfigkey: "DiscountPercentEarnedWhenReachingSales",
        AppConfigvalue: values.DiscountPercentEarnedWhenReachingSales,
      },
      {
        AppConfigkey: "HideSalesToDiscountOnReceipt",
        AppConfigvalue: values.HideSalesToDiscountOnReceipt,
      },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "CUSTOMER_LOYALTY",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=CUSTOMER_LOYALTY`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "EnableCustomerLoyaltySystem") {
            if (data.AppConfigvalue === "false") {
              formValues.EnableCustomerLoyaltySystem = false;
            } else {
              formValues.EnableCustomerLoyaltySystem = true;
              setEnableCustomerLoyaltySystem(true);
            }
          } else if (data.AppConfigkey === "DisableLoyaltyByDefault") {
            formValues.DisableLoyaltyByDefault =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "LoyaltyProgramOption") {
            formValues.LoyaltyProgramOption = data.AppConfigvalue;

            if (data.AppConfigvalue === "Advanced") {
              setLoyaltyProgramOptionAdvanced(true);
              setLoyaltyProgramOptionSimple(false);
            } else {
              setLoyaltyProgramOptionSimple(true);
            }
          } else if (data.AppConfigkey === "SpendAmountToPointRatio") {
            formValues.SpendAmountToPointRatio = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SpendAmountToPointRatio1") {
            formValues.SpendAmountToPointRatio1 = data.AppConfigvalue;
          } else if (data.AppConfigkey === "PointValue") {
            formValues.PointValue = data.AppConfigvalue;
          } else if (data.AppConfigkey === "MinimumNumberOfPointsToRedeem") {
            formValues.MinimumNumberOfPointsToRedeem = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "LoyaltyPointsEarnedNotIncludingTax"
          ) {
            formValues.LoyaltyPointsEarnedNotIncludingTax =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "PromptToUsePointsWhenAvailable") {
            formValues.PromptToUsePointsWhenAvailable =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HidePointsOnReceipt") {
            formValues.HidePointsOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "DisableGiftCardsSoldFromEarningLoyalty"
          ) {
            formValues.DisableGiftCardsSoldFromEarningLoyalty =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnablePointsForGiftCardPayments") {
            formValues.EnablePointsForGiftCardPayments =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "NumberOfSalesForDiscount") {
            formValues.NumberOfSalesForDiscount = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "DiscountPercentEarnedWhenReachingSales"
          ) {
            formValues.DiscountPercentEarnedWhenReachingSales =
              data.AppConfigvalue;
          } else if (data.AppConfigkey === "HideSalesToDiscountOnReceipt") {
            formValues.HideSalesToDiscountOnReceipt =
              data.AppConfigvalue === "false" ? false : true;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const data = [
    {
      name: "Enable Customer Loyalty System:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="EnableCustomerLoyaltySystem"
                name="EnableCustomerLoyaltySystem"
                onChange={handleChange}
                onInput={handleEnableCustomerLoyaltySystem}
              />
            </div>
          </div>
          {/* <div
            className={
              enableCustomerLoyaltySystem === true ? "" : "d-none"
            }
          >
            <div className="form-group row">
              <label className="col-form-label col-lg-2 ">
                Disable Loyalty By Default:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    className="form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    id="DisableLoyaltyByDefault"
                    name="DisableLoyaltyByDefault"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-form-label col-lg-2">
                Loyalty Program Option:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    as="select"
                    className="form-control form-small select"
                    id="LoyaltyProgramOption"
                    name="LoyaltyProgramOption"
                    onChange={handleChange}
                    onInput={handleLoyaltyProgramOption}
                  >
                    <option>Simple</option>
                    <option>Advanced</option>
                  </Field>
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2">
                Spend Amount To Point Ratio:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    type="text"
                    className="form-control"
                    id="SpendAmountToPointRatio"
                    name="SpendAmountToPointRatio"
                    onChange={handleChange}
                  />
                  <Field
                    type="text"
                    className="form-control"
                    id="SpendAmountToPointRatio1"
                    name="SpendAmountToPointRatio1"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2">
                Point Value:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    type="text"
                    className="form-control"
                    id="PointValue"
                    name="PointValue"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2">
                Minimum Number Of Points To Redeem:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    type="text"
                    className="form-control"
                    id="MinimumNumberOfPointsToRedeem"
                    name="MinimumNumberOfPointsToRedeem"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2 ">
                Loyalty Points Earned Not Including Tax:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    className="form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    id="LoyaltyPointsEarnedNotIncludingTax"
                    name="LoyaltyPointsEarnedNotIncludingTax"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2 ">
                Prompt To Use Points When Available:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    className="form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    id="PromptToUsePointsWhenAvailable"
                    name="PromptToUsePointsWhenAvailable"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2 ">
                Hide Points On Receipt:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    className="form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    id="HidePointsOnReceipt"
                    name="HidePointsOnReceipt"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2 ">
                Disable Gift Cards Sold From Earning Loyalty:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    className="form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    id="DisableGiftCardsSoldFromEarningLoyalty"
                    name="DisableGiftCardsSoldFromEarningLoyalty"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2 ">
                Enable Points For Gift Card Payments:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    className="form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    id="EnablePointsForGiftCardPayments"
                    name="EnablePointsForGiftCardPayments"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionSimple === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2">
                Number Of Sales For Discount:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    type="text"
                    className="form-control"
                    id="NumberOfSalesForDiscount"
                    name="NumberOfSalesForDiscount"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionSimple === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2">
                Discount Percent Earned When Reaching Sales:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    type="text"
                    className="form-control"
                    id="DiscountPercentEarnedWhenReachingSales"
                    name="DiscountPercentEarnedWhenReachingSales"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-group row ${loyaltyProgramOptionSimple === true ? "" : "d-none"
                }`}
            >
              <label className="col-form-label col-lg-2 ">
                Hide Sales To Discount On Receipt:
              </label>
              <div className="col-lg-10">
                <div className="input-group">
                  <Field
                    className="form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    id="HideSalesToDiscountOnReceipt"
                    name="HideSalesToDiscountOnReceipt"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div> */}
        </>
      ),
    },
  ];
  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  setVisibleCustomerLoyalty(!visibleCustomerLoyalty);
                  setcomingCustomerLoyalty(!!comingCustomerLoyalty);
                }}
              >
                Customer Loyalty
              </CLink>
            </h5>
          </div>
          <CCollapse
            visible={
              visibleCustomerLoyalty || props.visibleCustomerLoyaltyChange
            }
          >
            <div className="card-body">
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ handleChange }) => (
                  <Form>
                    <div
                      style={{
                        display: "flex",
                        width: "70%",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div style={{ width: "53%" }}>{el.input}</div>
                          </div>
                        ))}
                    </div>
                    {/* <div className="form-group row">
                        <label className="col-form-label col-lg-2 ">
                          Enable Customer Loyalty System:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{ width: "1.5em", height: "1.5em" }}
                              type="checkbox"
                              id="EnableCustomerLoyaltySystem"
                              name="EnableCustomerLoyaltySystem"
                              onChange={handleChange}
                              onInput={handleEnableCustomerLoyaltySystem}
                            />
                          </div>
                        </div>
                      </div> */}
                    <div
                      className={
                        enableCustomerLoyaltySystem === true ? "" : "d-none"
                      }
                    >
                      <div className="form-group row">
                        <label className="col-form-label col-lg-2 ">
                          Disable Loyalty By Default:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{
                                width: "1.5em",
                                height: "1.5em",
                                marginTop: "10px",
                              }}
                              type="checkbox"
                              id="DisableLoyaltyByDefault"
                              name="DisableLoyaltyByDefault"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-form-label col-lg-2">
                          Loyalty Program Option:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              as="select"
                              className="form-control form-small select"
                              id="LoyaltyProgramOption"
                              name="LoyaltyProgramOption"
                              onChange={handleChange}
                              onInput={handleLoyaltyProgramOption}
                            >
                              <option>Simple</option>
                              <option>Advanced</option>
                            </Field>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Spend Amount To Point Ratio:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="SpendAmountToPointRatio"
                              name="SpendAmountToPointRatio"
                              onChange={handleChange}
                            />
                            <Field
                              type="text"
                              className="form-control"
                              id="SpendAmountToPointRatio1"
                              name="SpendAmountToPointRatio1"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Point Value:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="PointValue"
                              name="PointValue"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Minimum Number Of Points To Redeem:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="MinimumNumberOfPointsToRedeem"
                              name="MinimumNumberOfPointsToRedeem"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2 ">
                          Loyalty Points Earned Not Including Tax:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{
                                width: "1.5em",
                                height: "1.5em",
                                marginTop: "10px",
                              }}
                              type="checkbox"
                              id="LoyaltyPointsEarnedNotIncludingTax"
                              name="LoyaltyPointsEarnedNotIncludingTax"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2 ">
                          Prompt To Use Points When Available:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{
                                width: "1.5em",
                                height: "1.5em",
                                marginTop: "10px",
                              }}
                              type="checkbox"
                              id="PromptToUsePointsWhenAvailable"
                              name="PromptToUsePointsWhenAvailable"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2 ">
                          Hide Points On Receipt:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{
                                width: "1.5em",
                                height: "1.5em",
                                marginTop: "10px",
                              }}
                              type="checkbox"
                              id="HidePointsOnReceipt"
                              name="HidePointsOnReceipt"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2 ">
                          Disable Gift Cards Sold From Earning Loyalty:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{
                                width: "1.5em",
                                height: "1.5em",
                                marginTop: "10px",
                              }}
                              type="checkbox"
                              id="DisableGiftCardsSoldFromEarningLoyalty"
                              name="DisableGiftCardsSoldFromEarningLoyalty"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2 ">
                          Enable Points For Gift Card Payments:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{
                                width: "1.5em",
                                height: "1.5em",
                                marginTop: "10px",
                              }}
                              type="checkbox"
                              id="EnablePointsForGiftCardPayments"
                              name="EnablePointsForGiftCardPayments"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionSimple === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Number Of Sales For Discount:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="NumberOfSalesForDiscount"
                              name="NumberOfSalesForDiscount"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionSimple === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Discount Percent Earned When Reaching Sales:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="DiscountPercentEarnedWhenReachingSales"
                              name="DiscountPercentEarnedWhenReachingSales"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          loyaltyProgramOptionSimple === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2 ">
                          Hide Sales To Discount On Receipt:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{ width: "1.5em", height: "1.5em" }}
                              type="checkbox"
                              id="HideSalesToDiscountOnReceipt"
                              name="HideSalesToDiscountOnReceipt"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleCustomerLoyalty(!visibleCustomerLoyalty);
                    setcomingCustomerLoyalty(!!comingCustomerLoyalty);
                  }}
                >
                  Customer Loyalty
                </CLink>
              </h5>
            </div>
            <CCollapse
              visible={
                visibleCustomerLoyalty || props.visibleCustomerLoyaltyChange
              }
            >
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ handleChange }) => (
                    <Form>
                      <div
                        style={{
                          display: "flex",
                          width: "70%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div style={{ width: "53%" }}>{el.input}</div>
                            </div>
                          ))}
                      </div>
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Customer Loyalty System:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableCustomerLoyaltySystem"
                          name="EnableCustomerLoyaltySystem"
                          onChange={handleChange}
                          onInput={handleEnableCustomerLoyaltySystem}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      enableCustomerLoyaltySystem === true ? "" : "d-none"
                    }
                  >
                    <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Disable Loyalty By Default:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="DisableLoyaltyByDefault"
                            name="DisableLoyaltyByDefault"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        Loyalty Program Option:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="LoyaltyProgramOption"
                            name="LoyaltyProgramOption"
                            onChange={handleChange}
                            onInput={handleLoyaltyProgramOption}
                          >
                            <option>Simple</option>
                            <option>Advanced</option>
                          </Field>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Spend Amount To Point Ratio:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="SpendAmountToPointRatio"
                            name="SpendAmountToPointRatio"
                            onChange={handleChange}
                          />
                          <Field
                            type="text"
                            className="form-control"
                            id="SpendAmountToPointRatio1"
                            name="SpendAmountToPointRatio1"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Point Value:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="PointValue"
                            name="PointValue"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Minimum Number Of Points To Redeem:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="MinimumNumberOfPointsToRedeem"
                            name="MinimumNumberOfPointsToRedeem"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2 ">
                        Loyalty Points Earned Not Including Tax:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="LoyaltyPointsEarnedNotIncludingTax"
                            name="LoyaltyPointsEarnedNotIncludingTax"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2 ">
                        Prompt To Use Points When Available:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="PromptToUsePointsWhenAvailable"
                            name="PromptToUsePointsWhenAvailable"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2 ">
                        Hide Points On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HidePointsOnReceipt"
                            name="HidePointsOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2 ">
                        Disable Gift Cards Sold From Earning Loyalty:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="DisableGiftCardsSoldFromEarningLoyalty"
                            name="DisableGiftCardsSoldFromEarningLoyalty"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionAdvanced === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2 ">
                        Enable Points For Gift Card Payments:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="EnablePointsForGiftCardPayments"
                            name="EnablePointsForGiftCardPayments"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionSimple === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Number Of Sales For Discount:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="NumberOfSalesForDiscount"
                            name="NumberOfSalesForDiscount"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionSimple === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Discount Percent Earned When Reaching Sales:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="DiscountPercentEarnedWhenReachingSales"
                            name="DiscountPercentEarnedWhenReachingSales"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${loyaltyProgramOptionSimple === true ? "" : "d-none"
                        }`}
                    >
                      <label className="col-form-label col-lg-2 ">
                        Hide Sales To Discount On Receipt:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="HideSalesToDiscountOnReceipt"
                            name="HideSalesToDiscountOnReceipt"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                      <button
                        type="submit"
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default CustomerLoyalty;
